import { ReactNode } from 'react';

import { RedirectToAuthPage } from 'modules/auth/components/RedirectToAuthPage';
import { chainsRoutesConfig } from 'domains/chains/routes';
import { useShouldSignInFromChainPage } from 'modules/chains/hooks/useShouldSignInFromChainPage';
import { useSignInWithRedirectURL } from 'modules/auth/hooks/useSignInWithRedirectURL';

export interface ProductsPageGuardProps {
  children: ReactNode;
}

export const ProductsPageGuard = ({ children }: ProductsPageGuardProps) => {
  const shouldSignIn = useShouldSignInFromChainPage();

  const { chainId } = chainsRoutesConfig.chainDetails.useParams();

  const signIn = useSignInWithRedirectURL({
    hasAPIKeysNotification: true,
    redirectURL: chainsRoutesConfig.chainDetails.generatePath(chainId),
  });

  if (shouldSignIn) {
    return <RedirectToAuthPage customSignIn={signIn} />;
  }

  return <>{children}</>;
};
